<template>
    <div class="Operationrecord">
        <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="操作记录" name="first">
        <div class="Operationrecord-content">
            <div class="margin-top1" style="overflow: hidden;">
                <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-width="100px">
                    <el-form-item label="类型" prop="type">
                        <el-select v-model="ruleForm.type" placeholder="选择类型" @change="SelectType" filterable>
                            <el-option
                                v-for="(item,index) in staff"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色" prop="roleId">
                        <el-select v-model="ruleForm.roleId" placeholder="选择类型" filterable>
                            <el-option
                                v-for="(item,index) in roleList"
                                :key="index"
                                :label="item.roleName+'-'+item.userName"
                                :value="item.roleId"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开始日期" prop="starttime">
                        <el-date-picker
                            style="width:210px;"
                            v-model="ruleForm.starttime"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择开始日期"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期" prop="endtime">
                        <el-date-picker
                            style="width:210px;"
                            v-model="ruleForm.endtime"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择结束日期"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="type" style="width: 40%;" class="searchInput">
                        <el-input v-model.trim="ruleForm.input" placeholder="操作内容、订单ID（模糊查询）" style="width: 60%;"></el-input>
                        <el-button type="primary" style="margin-left: 5px;" class="search" @click="searchForm">搜索</el-button>
                        <el-button type="primary" class="search" @click="searchReset">重置</el-button>
                    </el-form-item>
                </el-form>
                <!-- <el-button type="primary" style="float: right; margin-top: -50px;" @click="dialogvisible=true">出库记录导出</el-button> -->
                <el-popover
                    placement="left"
                    trigger="click"
                    style="float: right; margin-top: -50px;">
                    <div>
                        <el-date-picker
                            v-model="daochudata"
                            type="datetimerange"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                        <el-button type="primary" @click="daochusubmit" style="float: right; margin-left: 10px;">
                            确定
                        </el-button>
                    </div>
                    <el-button type="primary" slot="reference">
                        出库记录导出
                    </el-button>
                </el-popover>
            </div>

            <el-table :data="tableData" border style="width: 100%" v-loading="loading">
                <el-table-column width="200"  label="角色名" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.roleName}}-{{scope.row.userName}}</span>
                    </template>
                </el-table-column>
                <el-table-column width="250" prop="createTime" label="时间" align="center"></el-table-column>
                <el-table-column prop="operateName" label="操作内容" align="center"></el-table-column>
                <el-table-column width="250" prop="orderId" label="订单ID" align="center"></el-table-column>
                <el-table-column width="250" label="操作类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 3">国际运单生成</span>
                        <span v-if="scope.row.type == 5">采购单入库</span>
                        <span v-if="scope.row.type == 6">信息部订单确认完成</span>
                        <span v-if="scope.row.type == 7">国际运单出库</span>
                        <span v-if="scope.row.type == 8">订单出库</span>
                        <span v-if="scope.row.type == 10">国际运单作废</span>
                        <span v-if="scope.row.type == 11">信息核对异常</span>
                        <span v-if="scope.row.type == 13">确认退件</span>
                        <span v-if="scope.row.type == 15">确认取消异常</span>
                        <span v-if="scope.row.type == 17">确认转库存</span>
                        <span v-if="scope.row.type == 20">渠道确认</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
        </el-tab-pane>
            <el-tab-pane label="操作统计" name="second">
                <div class="Operationrecord-content">
            <div class="margin-top1" style="overflow: hidden;">
                <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-width="100px">
                    <el-form-item label="类型" prop="type">
                        <el-select v-model="ruleForm.type1" placeholder="选择类型" @change="SelectType1" filterable>
                            <el-option
                                v-for="(item,index) in staff"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色" prop="roleId">
                        <el-select v-model="ruleForm.roleId1" placeholder="选择类型" filterable>
                            <el-option
                                v-for="(item,index) in roleList1"
                                :key="index"
                                :label="item.roleName+'-'+item.userName"
                                :value="item.roleId"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开始日期" prop="starttime">
                        <el-date-picker
                            style="width:210px;"
                            v-model="ruleForm.starttime1"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择开始日期"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期" prop="endtime">
                        <el-date-picker
                            style="width:210px;"
                            v-model="ruleForm.endtime1"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择结束日期"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="type" class="searchInput">
                        <el-button type="primary" style="margin-left: 5px;" class="search" @click="search1">搜索</el-button>
                        <el-button type="primary" class="search" @click="searchReset1">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <el-table :data="tableData1" border style="width: 100%" v-loading="loading1" :span-method="arraySpanMethod">
                <el-table-column prop="time" label="时间" align="center"></el-table-column>
                <el-table-column label="操作类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">订单生成</span>
                        <span v-if="scope.row.type == 2">确认采购需求</span>
                        <span v-if="scope.row.type == 3">国际运单生成</span>
                        <span v-if="scope.row.type == 4">采购单生成</span>
                        <span v-if="scope.row.type == 5">采购单入库</span>
                        <span v-if="scope.row.type == 6">信息部订单确认完成</span>
                        <span v-if="scope.row.type == 7">国际运单出库</span>
                        <span v-if="scope.row.type == 8">订单出库</span>
                        <span v-if="scope.row.type == 9">订单外部拦截</span>
                        <span v-if="scope.row.type == 10">国际运单作废</span>
                        <span v-if="scope.row.type == 11">采购单信息核对错误</span>
                        <span v-if="scope.row.type == 12">申请退件</span>
                        <span v-if="scope.row.type == 13">确认退件</span>
                        <span v-if="scope.row.type == 14">申请取消异常</span>
                        <span v-if="scope.row.type == 15">确认取消异常</span>
                        <span v-if="scope.row.type == 16">申请转库存</span>
                        <span v-if="scope.row.type == 17">确认转库存</span>
                        <span v-if="scope.row.type == 18">取消拦截</span>
                        <span v-if="scope.row.type == 19">匹配库存出库</span>
                        <span v-if="scope.row.type == 20">渠道确认</span>
                        <span v-if="scope.row.type == 21">确认采购需求修改</span>
                        <span v-if="scope.row.type == 23">添加国内单</span>
                        <span v-if="scope.row.type == 24">公司余额充值</span>
                        <span v-if="scope.row.type == 25">采购需求还原</span>
                        <span v-if="scope.row.type == 26">采购单标记无效</span>
                        <span v-if="scope.row.type == 27">未知库存关联的采购单</span>
                        <span v-if="scope.row.type == 28">未知库存申请转库存</span>
                        <span v-if="scope.row.type == 29">未知库存申请退件</span>
                        <span v-if="scope.row.type == 30">匹配商城出库</span>
                        <span v-if="scope.row.type == 31">申请转未知</span>
                        <span v-if="scope.row.type == 32">确认转未知</span>
                        <span v-if="scope.row.type == 33">已退件</span>
                        <span v-if="scope.row.type == 34">信息核对还原</span>
                        <span v-if="scope.row.type == 35">出库确认还原</span>
                        <span v-if="scope.row.type == 36">采购单状态还原</span>
                        <span v-if="scope.row.type == 37">补充库存</span>
                        <span v-if="scope.row.type == 38">自建库存</span>
                        <span v-if="scope.row.type == 39">申请销毁库存</span>
                        <span v-if="scope.row.type == 40">确认销毁库存</span>
                        <span v-if="scope.row.type == 41">申请库存退件</span>
                        <span v-if="scope.row.type == 42">确认库存退件</span>
                        <span v-if="scope.row.type == 43">定时扣除仓储费用开始</span>
                        <span v-if="scope.row.type == 44">定时扣除仓储费用结束</span>
                        <span v-if="scope.row.type == 45">授权店铺</span>
                        <span v-if="scope.row.type == 46">绑定店铺</span>
                        <span v-if="scope.row.type == 47">解绑店铺</span>
                        <span v-if="scope.row.type == 48">shopee订单声明发货</span>
                        <span v-if="scope.row.type == 49">匹配cod退件</span>
                    </template>
                </el-table-column>
                <el-table-column label="数量" align="center">
                <el-table-column label="物流公司" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.operateLogPojos == null">--</div>
                        <div v-if="scope.row.operateLogPojos !== null">
                            <div v-for="(item,index) in scope.row.operateLogPojos" :key="index">
                                <span v-if="item.channelType == 1">三态</span>
                                <span v-if="item.channelType == 2">云途</span>
                                <span v-if="item.channelType == 3">燕文</span>
                                <span v-if="item.channelType == 4">第三方</span>
                                <span v-if="item.channelType == 5">k5</span> 
                                <span v-if="item.channelType == 6">递四方</span>
                                <span v-if="item.channelType == 7">云途（服装）</span>
                                <span v-if="item.channelType == 8">泰嘉</span>
                                <span v-if="item.channelType == 9">八达通</span>
                                <span v-if="item.channelType == 10">云途A</span>
                                <span v-if="item.channelType == 11">递四方A</span>
                                <span v-if="item.channelType == 12">捷岸</span>
                                <span v-if="item.channelType == 13">立德</span>
                                <span v-if="item.channelType == 14">艾姆勒</span>
                                <span v-if="item.channelType == 15">shopee物流</span>
                                <span v-if="item.channelType == 16">ozon物流</span>
                                <span v-if="item.channelType == 17">柏电</span>
                                <span v-if="item.channelType == 18">柏电自有</span>
                                <span v-if="item.channelType == 19">万立德</span>
                                <span v-if="item.channelType == 20">浩亿达</span>
                                <span v-if="item.channelType == 21">Cheer</span>
                                <span v-if="item.channelType == 22">辰达通</span>
                                <span v-if="item.channelType == 23">辰达通A</span>
                                <span v-if="item.channelType == 24">浩亿达_厦门</span>
                                <span v-if="item.channelType == 25">艾派</span>
                                <span v-if="item.channelType == 26">艾派_厦门</span>
                                <span v-if="item.channelType == 27">dealfy</span>
                                <span v-if="item.channelType == 28">菜鸟</span>
                                <span v-if="item.channelType == 29">艾派COD</span>
                                <span v-if="item.channelType == 30">欧邮通</span>
                                <span v-if="item.channelType == 31">菜鸟-海度</span>
                                <span v-if="item.channelType == 32">速卖通物流</span>
                                <span v-if="item.channelType == 33">Walmart_SWW</span>
                                <span v-if="item.channelType == 34">商壹国际</span>
                                <span v-if="item.channelType == 35">小包</span>
                                <span v-if="item.channelType == 36">mercadolibre物流</span>
                                <span v-if="item.channelType == 37">瀛方国际</span>
                                <!-- <el-divider></el-divider> -->
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="数量" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.operateLogPojos == null">{{scope.row.count}}</div>
                        <div v-if="scope.row.operateLogPojos !== null">
                            <div v-for="(item,i) in scope.row.operateLogPojos" :key="i">
                                <span>{{item.count}}</span>
                                <!-- <el-divider></el-divider> -->
                            </div>
                        </div>
                    </template>
                </el-table-column>
                </el-table-column>
            </el-table>
            <!-- <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                    :current-page="currentPage1"
                    :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total1"
                ></el-pagination>
            </div> -->
        </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
    name: "Operationrecord",
    data() {
        return {
            activeName: 'first',
            str: "",
            tableData: [],
            tableData1: [],
            loading:true,
            loading1:true,

            currentPage: 1,
            pagesize: 50,
            size: 50,
            total: 0,

            currentPage1: 1,
            pagesize1: 50,
            size1: 50,
            total1: 0,

            roleList:"",
            roleList1:"",

            staff: [
                {  name: "国际运单生成", value: 3 },
                {  name: "采购单入库", value: 5 },
                {  name: "信息部订单确认完成", value: 6 },
                {  name: "国际运单出库", value: 7 },
                {  name: "订单出库", value: 8 },
                {  name: "国际运单作废", value: 10 },
                {  name: "信息核对异常", value: 11 },
                {  name: "确认退件", value: 13 },
                {  name: "确认取消异常", value: 15 },
                {  name: "确认转库存", value: 17 },
                {  name: "渠道确认", value: 20 }
            ],
            ruleForm: {
                type: "", //选择类型
                starttime: "", //开始时间
                endtime: "", //结束时间
                roleId:"",//选择角色
                input: "",

                type1: "", //选择类型
                starttime1: "", //开始时间
                endtime1: "", //结束时间
                roleId1:"",//选择角色
            },
            dialogvisible: false,
            daochudata: []
        };
    },
    mounted() {},
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.getThisMonth();
        this.search();
        this.search1();
    },
    methods: {
        daochusubmit() {
            if (!this.daochudata.length) {
                this.$message.error("请选择导出时间段！")
                return
            }
            window.open(`${Baseurl}/orderController/moveExport?start=${this.daochudata[0]}&end=${this.daochudata[1]}`, 'target');
        },
        searchForm(){
            this.currentPage = 1
            this.search()
        },
        search() {
            var obj = {
                startTimeString: this.ruleForm.starttime,
                endTimeString: this.ruleForm.endtime,
                searchString: this.ruleForm.input,
                type: this.ruleForm.type,
                roleId: this.ruleForm.roleId,
                page: this.currentPage,
                size: this.size
            };
            ajaxPost(Baseurl + "operateLogController/selectOperateLogList",obj).then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.total;
                }
                this.loading = false;
            });
        },
        searchReset() {
            this.currentPage = 1
            this.ruleForm.type = "";
            this.ruleForm.roleId = "";
            this.ruleForm.starttime = "";
            this.ruleForm.endtime = "";
            this.ruleForm.input = "";
            this.roleList = []
            this.currentPage = 1
            this.search();
        },
        
        search1() {
            var obj = {
                startTimeString: this.ruleForm.starttime1,
                endTimeString: this.ruleForm.endtime1,
                type: this.ruleForm.type1,
                roleId: this.ruleForm.roleId1,
                // page: this.currentPage1,
                // size: this.size1
            };
            ajaxPost(Baseurl + "operateLogController/selectOperateLogStatistics",obj).then(res => {
                if(res.data.code == 200){
                    this.tableData1 = res.data.data;
                    // this.tableData1 = res.data.data.list;
                    // this.total1 = res.data.data.total;
                }
                this.loading1 = false;
            });
        },
        searchReset1() {
            this.currentPage = 1
            this.ruleForm.type1 = "";
            this.ruleForm.starttime1 = "";
            this.ruleForm.endtime1 = "";
            this.ruleForm.roleId1 = "";
            this.roleList1 = []
            this.search1();
        },

        SelectType(val){
            console.log(val)
            var obj = {
                type:val,
            }
            ajaxPost(Baseurl + "operateLogController/getOperateRoleNameList",obj).then(res => {
                if(res.data.code == 200){
                    this.roleList = res.data.data
                }
            });
        },
        SelectType1(val){
            console.log(val)
            var obj = {
                type:val,
            }
            ajaxPost(Baseurl + "operateLogController/getOperateRoleNameList",obj).then(res => {
                if(res.data.code == 200){
                    this.roleList1 = res.data.data
                }
            });
        },
        getThisMonth() {
            const nowDate = new Date()
            const nowTimeStamp = nowDate.getTime()
            const nowYear = nowDate.getFullYear()
            const nowMonth = nowDate.getMonth() + 1
            const nowDay = nowDate.getDate()

            const startTimeStamp = nowTimeStamp - (3600 * 1000 * 24 * 30)
            const startDate = new Date(startTimeStamp)
            const startYear = startDate.getFullYear()
            const startMonth = startDate.getMonth() + 1
            const startDay = startDate.getDate()

            this.ruleForm.starttime = `${ nowYear }-${ nowMonth }-${ nowDay } 00:00:00`
            this.ruleForm.endtime = `${ nowYear }-${ nowMonth }-${ nowDay } 23:59:59`
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search()
        },

        handleSizeChange1(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
        },
        handleCurrentChange1(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage1 = val;
            this.search1()
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            // console.log(columnIndex)
            if (row.operateLogPojos == null) {
                if (columnIndex === 3) {
                    return [1,2];
                } else if (columnIndex === 2) {
                    return [0,2];
                }
            }
        },
    }
};
</script>

<style lang="scss">
.Operationrecord {
    width: 98%;
    margin-bottom: 50px;
    overflow: hidden;
    .Operationrecord-content {
        margin-top: 20px;
        .el-form-item {
            overflow: hidden;
            width: 20%;
            margin-bottom: 18px;
            float: left;
        }
        .searchInput .el-form-item__content{
            margin-left: 0px!important;
        }
        .Reportform_tiem {
            overflow: hidden;
            border-top: 1px solid #eee;
            padding: 15px 0;
            .search-result-text {
                font-size: 14px;
                color: #606266;
                padding: 0;
            }
            .el-radio-group {
                display: inline-block;
                line-height: 1;
                vertical-align: middle;
                font-size: 0;
                margin-left: 20px;
            }
        }
        .paging {
            width: 40%;
            margin: 20px auto;
        }
        .page {
            position: fixed;
            width: 100%;
            bottom: 0;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
        }
    }
}
</style>
